import { useAuthStore } from '@store/authStore';
import authService from '@services/authService';
import FamilySetupDialog from '@components/profile/FamilySetupDialog';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for authenticated users only.
 * Accepts either a live token session or a hydrated auth store so brief
 * localStorage/user-shape mismatches do not bounce players to /login.
 * Family setup is an overlay after the destination page paints — not a redirect.
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  const ok =
    authService.hasActiveSession() ||
    Boolean(isAuthenticated && user?.id) ||
    Boolean(isAuthenticated && authService.isAuthenticated());

  if (!ok) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      <FamilySetupDialog />
    </>
  );
};

export default PrivateRoute;
